<template>
    <div id="mobile-tooth-selector-container"
         @touchstart="processTouchStart"
         @touchmove="processTouchMove"
         @touchend="processTouchEnd"
    >
        <div id="mobile-tooth-selector" :class="'selected-jaw-' + selectedJaw">
            <div style="position: absolute; width: 100%; height: 100%; z-index: 1;" @click="function(e) { toggleJaw(e, 'none')}" />
            <div key="upper" class="upper-jaw">
                <svg id="svg-upper"
                     xmlns:dc="http://purl.org/dc/elements/1.1/"
                     xmlns:cc="http://creativecommons.org/ns#"
                     xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     viewBox="0 0 744.09 890"
                     @click="function(e) { toggleJaw(e, 'upper')}"
                >
                    <metadata id="metadata469">
                        <rdf:RDF>
                            <cc:Work>
                                <dc:format>image/svg+xml</dc:format>
                                <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                                <dc:title />
                            </cc:Work>
                        </rdf:RDF>
                    </metadata>
                    <defs>
                        <linearGradient id="teeth-upper-fill-7"
                                        x2="1"
                                        gradientTransform="rotate(85 -252.27 444.077) scale(36.4365)"
                                        gradientUnits="userSpaceOnUse"
                        >
                            <stop id="stop172" offset="0" stop-color="#fff" />
                            <stop id="stop174" offset=".1" stop-color="#fff" />
                            <stop id="stop176" offset=".3" stop-color="#eeeff4" />
                            <stop id="stop178" offset=".69" stop-color="#dde0d6" />
                            <stop id="stop180" offset=".74" stop-color="#dde0d6" />
                            <stop id="stop182" offset="1" stop-color="#fff" />
                        </linearGradient>

                        <linearGradient id="linearGradient4459-9"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="573.57"
                                        y1="680.61"
                                        x2="717.38"
                                        y2="680.61"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4467-2"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="598.61"
                                        y1="796.41"
                                        x2="706.95"
                                        y2="796.41"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4451-0"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="576.38"
                                        y1="551.09"
                                        x2="718.06"
                                        y2="551.09"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4772-9"
                                        gradientTransform="matrix(-1 0 0 1 749.942 .763)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="599.94"
                                        y1="423.13"
                                        x2="716.24"
                                        y2="423.13"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4724-3"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="583.79"
                                        y1="320.35"
                                        x2="707.44"
                                        y2="295.52"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4699-1"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="557.27"
                                        y1="231.86"
                                        x2="648.72"
                                        y2="163.3"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4652-6"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="502.59"
                                        y1="187.54"
                                        x2="557.68"
                                        y2="90.58"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4605-5"
                                        gradientTransform="matrix(-1 0 0 1 747.99 -.352)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="422.34"
                                        y1="182.84"
                                        x2="441.9"
                                        y2="40.95"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4459-9-5"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="573.57"
                                        y1="680.61"
                                        x2="717.38"
                                        y2="680.61"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4467-2-7"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="598.61"
                                        y1="796.41"
                                        x2="706.95"
                                        y2="796.41"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4451-0-2"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="576.38"
                                        y1="551.09"
                                        x2="718.06"
                                        y2="551.09"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4772-9-2"
                                        gradientTransform="translate(-2.502 .206)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="599.94"
                                        y1="423.13"
                                        x2="716.24"
                                        y2="423.13"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4724-3-1"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="583.79"
                                        y1="320.35"
                                        x2="707.44"
                                        y2="295.52"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4699-1-3"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="557.27"
                                        y1="231.86"
                                        x2="648.72"
                                        y2="163.3"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4652-6-2"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="502.59"
                                        y1="187.54"
                                        x2="557.68"
                                        y2="90.58"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradient4605-5-6"
                                        gradientTransform="translate(-.55 -.908)"
                                        xlink:href="#teeth-upper-fill-7"
                                        x1="422.34"
                                        y1="182.84"
                                        x2="441.9"
                                        y2="40.95"
                                        gradientUnits="userSpaceOnUse"
                        />
                    </defs>

                    <g id="teeth-upper-gum">
                        <path id="path4484-0"
                              style="fill:#f9c1cb;fill-opacity:1;fill-rule:evenodd;stroke:none;"
                              d="M53.38 181.2c-40.68 83.33-7.1 45.26 24.44 47.3 32.65 2.08 33.37.86 67.8 23.46 34.4 22.6 22.62 76.1 97.74-15.6 28.4-40.44 131.55-43.98 131.55-43.98s107.1 4.24 130.4 44.14c79.1 95.6 63.4 38.2 97.8 15.6s35.2-21.4 67.8-23.48c31.6-2.03 65.1 36.05 24.5-47.3C624 35.34 425.3 16.88 374.6 16.9c-50.65 0-249.93 18.27-321.22 164.3z"
                        />
                        <path id="path393"
                              d="M21.08 303.78C6.28 430.64 6.3 452.62 8.96 584.6s18.18 301.04 81.82 291.94C172.25 864.9 194.54 730.42 192.8 643.2c-1.7-87.24-40.3-188.4-19.2-290.93 21.2-102.55-137.7-175.36-152.5-48.5z"
                              style="fill:#f9c1cb;fill-rule:evenodd"
                        />
                        <path d="M726.36 303.22c14.8 126.86 14.78 148.84 12.12 280.82s-18.18 301.04-81.82 291.94C575.2 864.34 552.9 729.86 554.63 642.63c1.7-87.23 40.3-188.38 19.2-290.92-21.2-102.5 137.7-175.3 152.5-48.5z"
                              style="fill:#f9c1cb;fill-rule:evenodd"
                        />
                    </g>

                    <g id="teeth-upper-tooth">
                        <path id="tooth11"
                              :class="isSelected(11)?'selected':''"
                              :style="getStyle(11)"
                              style="fill:url(#linearGradient4605-5);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M262.5 88.67s8.72 65.36 32.36 84.75c29.23 24 64.67 19.97 74.66-90.88 3.63-40.3-3.12-41.17-22.15-43.52-12.48-1.54-34.34-2.06-43.4.7-32.38 9.87-47.32 17.46-41.47 48.95z"
                              @click="handleClick(event,11)"
                        />
                        <path id="tooth12"
                              :class="isSelected(12)?'selected':''"
                              :style="getStyle(12)"
                              style="fill:url(#linearGradient4652-6);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M177.8 140.13s17.45 38.35 40.52 47.42c27.23 10.7 57.67-6.18 30.92-98.46-5.9-20.4-20.1-17.9-32.45-15.5-6.7 1.3-17.4 7-23 11.4-23.4 17.9-30.7 26.4-16 55z"
                              @click="handleClick(event,12)"
                        />
                        <path id="tooth13"
                              :class="isSelected(13)?'selected':''"
                              :style="getStyle(13)"
                              style="fill:url(#linearGradient4699-1);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M99.44 215.8s38.2 26.54 74.33 28.02c31.15 1.28 46.25-34.33-11.92-101.78-21.68-25.14-35.12-18.06-50.35-11.12-12.54 5.7-14.76 11.1-19.54 30.16-4.86 19.4-9.25 40.92 7.48 54.72z"
                              @click="handleClick(event,13)"
                        />
                        <path id="tooth14"
                              :class="isSelected(14)?'selected':''"
                              :style="getStyle(14)"
                              style="fill:url(#linearGradient4724-3);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M155.2 339.43c-15.56 23.75-50.55 27.26-78.25 14.9-27.7-12.35-47.96-45.7-31.3-81.9 12.4-27 53.22-21.48 79.5-6.35 29.16 16.8 45.63 49.6 30.06 73.35z"
                              @click="handleClick(event,14)"
                        />
                        <path id="tooth15"
                              :class="isSelected(15)?'selected':''"
                              :style="getStyle(15)"
                              style="fill:url(#linearGradient4772-9);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M141.1 470c-18.23 22.55-54.72 16.55-78.86-2.46-24.14-19-40.52-67.94-17.24-91.1 21.72-21.6 65.38-14.6 82.43 6.25 20.95 25.6 31.02 65.8 13.68 87.3z"
                              @click="handleClick(event,15)"
                        />
                        <path id="tooth16"
                              :class="isSelected(16)?'selected':''"
                              :style="getStyle(16)"
                              style="fill:url(#linearGradient4451-0);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M159.75 602.35c-20.45 20.58-62.1 14.54-91.88-2.06-41.2-23-47.62-80.2-24.33-103.4 21.72-21.6 76.8-8.7 99.38 17.3 21.7 25 42.05 62.7 16.83 88.1z"
                              @click="handleClick(event,16)"
                        />
                        <path id="tooth17"
                              :class="isSelected(17)?'selected':''"
                              :style="getStyle(17)"
                              style="fill:url(#linearGradient4459-9);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M163.55 733.43c-17.02 23.85-76.96 11.57-98.58 3.45-47.32-17.78-38.15-93.56-17.63-115.14 21.1-22.2 69.1 3.57 88.74 22.02 20.55 19.3 56.47 49 27.47 89.67z"
                              @click="handleClick(event,17)"
                        />
                        <path id="tooth18"
                              :class="isSelected(18)?'selected':''"
                              :style="getStyle(18)"
                              style="fill:url(#linearGradient4467-2);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M137.65 822.54c-18.25 22.56-58.6 25.1-77.3 15.67-23.96-12-24.02-56.6-7.78-76.5 15.17-18.5 63.54-16.3 80.07 1.2 19.7 20.8 22.35 38.3 5 59.7z"
                              @click="handleClick(event,18)"
                        />
                        <path id="tooth21"
                              :class="isSelected(21)?'selected':''"
                              :style="getStyle(21)"
                              style="fill:url(#linearGradient4605-5-6);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M484.94 88.12s-8.72 65.35-32.36 84.75c-29.23 23.98-64.67 19.96-74.66-90.9-3.63-40.27 3.12-41.15 22.15-43.5 12.48-1.55 34.34-2.06 43.4.7 32.38 9.86 47.32 17.45 41.47 48.95z"
                              @click="handleClick(event,21)"
                        />
                        <path id="tooth22"
                              :class="isSelected(22)?'selected':''"
                              :style="getStyle(22)"
                              style="fill:url(#linearGradient4652-6-2);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M569.63 139.57s-17.44 38.36-40.5 47.42c-27.24 10.7-57.68-6.2-30.93-98.5 5.9-20.4 20.1-17.9 32.45-15.5 6.6 1.3 17.36 7 23 11.4 23.32 17.9 30.7 26.4 15.98 55z"
                              @click="handleClick(event,22)"
                        />
                        <path id="tooth23"
                              :class="isSelected(23)?'selected':''"
                              :style="getStyle(23)"
                              style="fill:url(#linearGradient4699-1-3);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M648 215.25s-38.2 26.53-74.33 28.02c-31.15 1.27-46.25-34.34 11.92-101.8 21.6-25.13 35.1-18.05 50.3-11.1 12.5 5.7 14.7 11.1 19.5 30.15 4.8 19.4 9.2 40.92-7.5 54.73z"
                              @click="handleClick(event,23)"
                        />
                        <path id="tooth24"
                              :class="isSelected(24)?'selected':''"
                              :style="getStyle(24)"
                              style="fill:url(#linearGradient4724-3-1);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M592.23 338.88c15.57 23.74 50.56 27.26 78.26 14.9 27.6-12.36 47.9-45.7 31.3-81.9-12.4-27-53.3-21.5-79.5-6.35-29.2 16.8-45.7 49.6-30.1 73.35z"
                              @click="handleClick(event,24)"
                        />
                        <path id="tooth25"
                              :class="isSelected(25)?'selected':''"
                              :style="getStyle(25)"
                              style="fill:url(#linearGradient4772-9-2);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M606.33 469.44c18.24 22.55 54.73 16.55 78.87-2.46 24.14-19 40.52-67.94 17.24-91.1-21.72-21.6-65.38-14.6-82.43 6.25-20.9 25.63-31 65.86-13.6 87.3z"
                              @click="handleClick(event,25)"
                        />
                        <path id="tooth26"
                              :class="isSelected(26)?'selected':''"
                              :style="getStyle(26)"
                              style="fill:url(#linearGradient4451-0-2);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M587.7 601.8c20.44 20.58 62.1 14.53 91.87-2.06 41.2-23 47.6-80.17 24.33-103.32-21.72-21.6-76.8-8.7-99.38 17.3-21.7 24.97-42.05 62.7-16.83 88.08z"
                              @click="handleClick(event,26)"
                        />
                        <path id="tooth27"
                              :class="isSelected(27)?'selected':''"
                              :style="getStyle(27)"
                              style="fill:url(#linearGradient4459-9-5);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M583.9 732.87c17 23.86 76.95 11.58 98.57 3.46 47.32-17.8 38.15-93.57 17.63-115.14-21.1-22.2-69.1 3.5-88.74 22-20.55 19.3-56.47 49-27.47 89.6z"
                              @click="handleClick(event,27)"
                        />
                        <path id="tooth28"
                              :class="isSelected(28)?'selected':''"
                              :style="getStyle(28)"
                              style="fill:url(#linearGradient4467-2-7);fill-opacity:1.0;fill-rule:evenodd;stroke:none;"
                              d="M609.8 821.98c18.24 22.56 58.58 25.1 77.3 15.68 23.95-12.07 24-56.68 7.77-76.5-15.17-18.55-63.54-16.33-80.07 1.1-19.7 20.8-22.35 38.27-5 59.72z"
                              @click="handleClick(event,28)"
                        />
                    </g>

                    <g id="teeth-upper-texts">
                        <text xml:space="preserve"
                              x="433.42178"
                              y="118.52154"
                              v-html="getToothTexts(21, 433.42178, 118.52154)"
                        />
                        <text xml:space="preserve"
                              x="527.15228"
                              y="146.21378"
                              v-html="getToothTexts(22, 527.15228, 146.21378)"
                        />
                        <text xml:space="preserve"
                              x="600.82513"
                              y="200.55978"
                              v-html="getToothTexts(23, 600.82513, 200.55978)"
                        />
                        <text xml:space="preserve"
                              x="648.04224"
                              y="320.86707"
                              v-html="getToothTexts(24, 648.04224, 320.86707)"
                        />
                        <text xml:space="preserve"
                              x="658.05573"
                              y="438.36673"
                              v-html="getToothTexts(25, 658.05573, 438.36673)"
                        />
                        <text xml:space="preserve"
                              x="648.05573"
                              y="562.75098"
                              v-html="getToothTexts(26, 648.05573, 562.75098)"
                        />
                        <text xml:space="preserve"
                              x="653.01727"
                              y="700.90442"
                              v-html="getToothTexts(27, 653.01727, 700.90442)"
                        />
                        <text xml:space="preserve"
                              x="654.49805"
                              y="809.51947"
                              v-html="getToothTexts(28, 654.49805, 809.51947)"
                        />
                        <text xml:space="preserve"
                              x="320.36444"
                              y="118.4446"
                              v-html="getToothTexts(11, 320.36444, 118.4446)"
                        />
                        <text xml:space="preserve"
                              x="223.07625"
                              y="146.13684"
                              v-html="getToothTexts(12, 223.07625, 146.13684)"
                        />
                        <text xml:space="preserve"
                              x="151.03801"
                              y="200.92514"
                              v-html="getToothTexts(13, 151.03801, 200.92514)"
                        />
                        <text xml:space="preserve"
                              x="100.69201"
                              y="320.34784"
                              v-html="getToothTexts(14, 100.69201, 320.34784)"
                        />
                        <text xml:space="preserve"
                              x="92.768944"
                              y="438.4437"
                              v-html="getToothTexts(15, 92.768944, 438.4437)"
                        />
                        <text xml:space="preserve"
                              x="101.1343"
                              y="563.2702"
                              v-html="getToothTexts(16, 101.1343, 563.2702)"
                        />
                        <text xml:space="preserve"
                              x="100.69201"
                              y="700.98132"
                              v-html="getToothTexts(17, 100.69201, 700.98132)"
                        />
                        <text xml:space="preserve"
                              x="93.730476"
                              y="808.63489"
                              v-html="getToothTexts(18, 93.730476, 808.63489)"
                        />
                    </g>
                </svg>
            </div>

            <div key="lower" class="lower-jaw">
                <svg id="svg-lower"
                     xmlns:dc="http://purl.org/dc/elements/1.1/"
                     xmlns:cc="http://creativecommons.org/ns#"
                     xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     viewBox="0 0 744.09 890"
                     @click="function(e) { toggleJaw(e, 'lower')} "
                >
                    <metadata id="metadata469">
                        <rdf:RDF>
                            <cc:Work>
                                <dc:format>image/svg+xml</dc:format>
                                <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                                <dc:title />
                            </cc:Work>
                        </rdf:RDF>
                    </metadata>
                    <defs>
                        <linearGradient id="teeth-lower-fill-7"
                                        x2="1"
                                        gradientTransform="rotate(85 -252.27 444.077) scale(36.4365)"
                                        gradientUnits="userSpaceOnUse"
                        >
                            <stop id="stop172" offset="0" stop-color="#fff" />
                            <stop id="stop174" offset=".1" stop-color="#fff" />
                            <stop id="stop176" offset=".3" stop-color="#eeeff4" />
                            <stop id="stop178" offset=".69" stop-color="#dde0d6" />
                            <stop id="stop180" offset=".74" stop-color="#dde0d6" />
                            <stop id="stop182" offset="1" stop-color="#fff" />
                        </linearGradient>
                        <linearGradient id="linearGradientLower4459-9"
                                        gradientTransform="matrix(-1,0,0,1,747.99,-0.352)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="573.57"
                                        y1="680.61"
                                        x2="717.38"
                                        y2="680.61"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4467-2"
                                        gradientTransform="matrix(-1,0,0,1,747.99,-0.352)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="598.61"
                                        y1="796.41"
                                        x2="706.95"
                                        y2="796.41"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4451-0"
                                        gradientTransform="matrix(-1,0,0,1,747.99,-0.352)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="576.38"
                                        y1="551.09"
                                        x2="718.06"
                                        y2="551.09"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4772-9"
                                        gradientTransform="matrix(-1,0,0,1,749.942,0.763)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="599.94"
                                        y1="423.13"
                                        x2="716.24"
                                        y2="423.13"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4724-3"
                                        gradientTransform="matrix(-1,0,0,1,747.99,-0.352)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="583.79"
                                        y1="320.35"
                                        x2="707.44"
                                        y2="295.52"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4699-1"
                                        gradientTransform="matrix(-1,0,0,1,747.99,-0.352)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="557.27"
                                        y1="231.86"
                                        x2="648.72"
                                        y2="163.3"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4652-6"
                                        gradientTransform="matrix(-1.0585582,0,0,1.0176908,779.82512,-3.7262196)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="502.59"
                                        y1="187.54"
                                        x2="557.68"
                                        y2="90.58"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4605-5"
                                        gradientTransform="matrix(-0.96164839,0,0,0.82261406,733.5112,14.407964)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="422.34"
                                        y1="182.84"
                                        x2="441.9"
                                        y2="40.95"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4459-9-5"
                                        gradientTransform="translate(-0.55,-0.908)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="573.57"
                                        y1="680.61"
                                        x2="717.38"
                                        y2="680.61"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4467-2-7"
                                        gradientTransform="translate(-0.55,-0.908)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="598.61"
                                        y1="796.41"
                                        x2="706.95"
                                        y2="796.41"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4451-0-2"
                                        gradientTransform="translate(-0.55,-0.908)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="576.38"
                                        y1="551.09"
                                        x2="718.06"
                                        y2="551.09"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4772-9-2"
                                        gradientTransform="translate(-2.502,0.206)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="599.94"
                                        y1="423.13"
                                        x2="716.24"
                                        y2="423.13"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4724-3-1"
                                        gradientTransform="translate(-0.55,-0.908)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="583.79"
                                        y1="320.35"
                                        x2="707.44"
                                        y2="295.52"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4699-1-3"
                                        gradientTransform="translate(-0.55,-0.908)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="557.27"
                                        y1="231.86"
                                        x2="648.72"
                                        y2="163.3"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4652-6-2"
                                        gradientTransform="matrix(1.0468596,0,0,1.0265276,-25.624457,-3.9675398)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="502.59"
                                        y1="187.54"
                                        x2="557.68"
                                        y2="90.58"
                                        gradientUnits="userSpaceOnUse"
                        />
                        <linearGradient id="linearGradientLower4605-5-6"
                                        gradientTransform="matrix(0.93288468,0,0,0.81550932,28.976137,16.123117)"
                                        xlink:href="#teeth-lower-fill-7"
                                        x1="422.34"
                                        y1="182.84"
                                        x2="441.9"
                                        y2="40.95"
                                        gradientUnits="userSpaceOnUse"
                        />
                    </defs>

                    <g id="teeth-lower-gum" transform="matrix(1,0,0,-1,0,893.79226)">
                        <path style="fill:#f9c1cb;fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 53.38,181.2 c -40.68,83.33 -7.1,45.26 24.44,47.3 32.65,2.08 33.37,0.86 67.8,23.46 34.4,22.6 22.62,76.1 97.74,-15.6 28.4,-40.44 131.55,-43.98 131.55,-43.98 0,0 107.1,4.24 130.4,44.14 79.1,95.6 63.4,38.2 97.8,15.6 34.4,-22.6 35.2,-21.4 67.8,-23.48 31.6,-2.03 65.1,36.05 24.5,-47.3 C 624,35.34 425.3,16.88 374.6,16.9 323.95,16.9 124.67,35.17 53.38,181.2 Z"
                        />
                        <path d="M 21.08,303.78 C 6.28,430.64 6.3,452.62 8.96,584.6 11.62,716.58 27.14,885.64 90.78,876.54 172.25,864.9 194.54,730.42 192.8,643.2 191.1,555.96 152.5,454.8 173.6,352.27 194.8,249.72 35.9,176.91 21.1,303.77 Z"
                              style="fill:#f9c1cb;fill-rule:evenodd"
                        />
                        <path d="m 726.36,303.22 c 14.8,126.86 14.78,148.84 12.12,280.82 C 735.82,716.02 720.3,885.08 656.66,875.98 575.2,864.34 552.9,729.86 554.63,642.63 c 1.7,-87.23 40.3,-188.38 19.2,-290.92 -21.2,-102.5 137.7,-175.3 152.5,-48.5 z"
                              style="fill:#f9c1cb;fill-rule:evenodd"
                        />
                    </g>

                    <g id="teeth-lower-tooth" transform="matrix(1,0,0,-1,0,893.79226)">
                        <path id="tooth41"
                              :class="isSelected(41)?'selected':''"
                              :style="getStyle(41)"
                              style="fill:url(#linearGradientLower4605-5);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 266.64052,87.638712 c 0,0 8.38558,53.766058 31.11895,69.716538 28.10898,19.74274 62.1898,16.4276 71.79666,-74.759161 3.49079,-33.151347 -3.00034,-33.867022 -21.30051,-35.800164 -12.00137,-1.266826 -33.023,-1.694585 -41.73554,0.57583 -31.13817,8.1192 -45.5052,14.36284 -39.87956,40.266957 z"
                              @click="handleClick(event,41)"
                        />
                        <path id="tooth42"
                              :class="isSelected(42)?'selected':''"
                              :style="getStyle(42)"
                              style="fill:url(#linearGradientLower4652-6);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 176.2458,139.24102 c 0,0 18.47184,39.02844 42.89278,48.2589 28.82454,10.88929 61.04705,-6.28933 32.73062,-100.201839 -6.24549,-20.760892 -21.27702,-18.216665 -34.35021,-15.774207 -7.09234,1.322998 -18.41892,7.123836 -24.34684,11.601675 -24.77026,18.216661 -32.49774,26.867041 -16.93693,55.972991 z"
                              @click="handleClick(event,42)"
                        />
                        <path id="tooth43"
                              :class="isSelected(43)?'selected':''"
                              :style="getStyle(43)"
                              style="fill:url(#linearGradientLower4699-1);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 99.44,215.8 c 0,0 38.2,26.54 74.33,28.02 31.15,1.28 46.25,-34.33 -11.92,-101.78 -21.68,-25.14 -35.12,-18.06 -50.35,-11.12 -12.54,5.7 -14.76,11.1 -19.54,30.16 -4.86,19.4 -9.25,40.92 7.48,54.72 z"
                              @click="handleClick(event,43)"
                        />
                        <path id="tooth44"
                              :class="isSelected(44)?'selected':''"
                              :style="getStyle(44)"
                              style="fill:url(#linearGradientLower4724-3);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 155.2,339.43 c -15.56,23.75 -50.55,27.26 -78.25,14.9 -27.7,-12.35 -47.96,-45.7 -31.3,-81.9 12.4,-27 53.22,-21.48 79.5,-6.35 29.16,16.8 45.63,49.6 30.06,73.35 z"
                              @click="handleClick(event,44)"
                        />
                        <path id="tooth45"
                              :class="isSelected(45)?'selected':''"
                              :style="getStyle(45)"
                              style="fill:url(#linearGradientLower4772-9);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="M 141.1,470 C 122.87,492.55 86.38,486.55 62.24,467.54 38.1,448.54 21.72,399.6 45,376.44 c 21.72,-21.6 65.38,-14.6 82.43,6.25 20.95,25.6 31.02,65.8 13.68,87.3 z"
                              @click="handleClick(event,45)"
                        />
                        <path id="tooth46"
                              :class="isSelected(46)?'selected':''"
                              :style="getStyle(46)"
                              style="fill:url(#linearGradientLower4451-0);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 159.75,602.35 c -20.45,20.58 -62.1,14.54 -91.88,-2.06 -41.2,-23 -47.62,-80.2 -24.33,-103.4 21.72,-21.6 76.8,-8.7 99.38,17.3 21.7,25 42.05,62.7 16.83,88.1 z"
                              @click="handleClick(event,46)"
                        />
                        <path id="tooth47"
                              :class="isSelected(47)?'selected':''"
                              :style="getStyle(47)"
                              style="fill:url(#linearGradientLower4459-9);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="M 163.55,733.43 C 146.53,757.28 86.59,745 64.97,736.88 17.65,719.1 26.82,643.32 47.34,621.74 c 21.1,-22.2 69.1,3.57 88.74,22.02 20.55,19.3 56.47,49 27.47,89.67 z"
                              @click="handleClick(event,47)"
                        />
                        <path id="tooth48"
                              :class="isSelected(48)?'selected':''"
                              :style="getStyle(48)"
                              style="fill:url(#linearGradientLower4467-2);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 137.65,822.54 c -18.25,22.56 -58.6,25.1 -77.3,15.67 -23.96,-12 -24.02,-56.6 -7.78,-76.5 15.17,-18.5 63.54,-16.3 80.07,1.2 19.7,20.8 22.35,38.3 5,59.7 z"
                              @click="handleClick(event,48)"
                        />
                        <path id="tooth31"
                              :class="isSelected(31)?'selected':''"
                              :style="getStyle(31)"
                              style="fill:url(#linearGradientLower4605-5-6);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 481.88232,88.726281 c 0,0 -8.13475,53.293539 -30.18815,69.114419 -27.26822,19.55591 -60.32965,16.27756 -69.64917,-74.129801 -3.38637,-32.840561 2.9106,-33.558209 20.66339,-35.474655 11.64241,-1.26404 32.03527,-1.67995 40.4872,0.570856 30.20681,8.040922 44.14411,14.230637 38.68673,39.919181 z"
                              @click="handleClick(event,31)"
                        />
                        <path id="tooth32"
                              :class="isSelected(32)?'selected':''"
                              :style="getStyle(32)"
                              style="fill:url(#linearGradientLower4652-6-2);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 571.27394,140.23701 c 0,0 -18.25723,39.37759 -42.39781,48.67793 -28.51645,10.98385 -60.38286,-6.36447 -32.37937,-101.112965 6.17647,-20.941163 21.04188,-18.374844 33.9706,-15.911178 6.90927,1.334486 18.17348,7.185694 24.07777,11.702415 24.41276,18.374848 32.13859,27.100328 16.72881,56.459018 z"
                              @click="handleClick(event,32)"
                        />
                        <path id="tooth33"
                              :class="isSelected(33)?'selected':''"
                              :style="getStyle(33)"
                              style="fill:url(#linearGradientLower4699-1-3);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 648,215.25 c 0,0 -38.2,26.53 -74.33,28.02 -31.15,1.27 -46.25,-34.34 11.92,-101.8 21.6,-25.13 35.1,-18.05 50.3,-11.1 12.5,5.7 14.7,11.1 19.5,30.15 4.8,19.4 9.2,40.92 -7.5,54.73 z"
                              @click="handleClick(event,33)"
                        />
                        <path id="tooth34"
                              :class="isSelected(34)?'selected':''"
                              :style="getStyle(34)"
                              style="fill:url(#linearGradientLower4724-3-1);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 592.23,338.88 c 15.57,23.74 50.56,27.26 78.26,14.9 27.6,-12.36 47.9,-45.7 31.3,-81.9 -12.4,-27 -53.3,-21.5 -79.5,-6.35 -29.2,16.8 -45.7,49.6 -30.1,73.35 z"
                              @click="handleClick(event,34)"
                        />
                        <path id="tooth35"
                              :class="isSelected(35)?'selected':''"
                              :style="getStyle(35)"
                              style="fill:url(#linearGradientLower4772-9-2);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 606.33,469.44 c 18.24,22.55 54.73,16.55 78.87,-2.46 24.14,-19 40.52,-67.94 17.24,-91.1 -21.72,-21.6 -65.38,-14.6 -82.43,6.25 -20.9,25.63 -31,65.86 -13.6,87.3 z"
                              @click="handleClick(event,35)"
                        />
                        <path id="tooth36"
                              :class="isSelected(36)?'selected':''"
                              :style="getStyle(36)"
                              style="fill:url(#linearGradientLower4451-0-2);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 587.7,601.8 c 20.44,20.58 62.1,14.53 91.87,-2.06 41.2,-23 47.6,-80.17 24.33,-103.32 -21.72,-21.6 -76.8,-8.7 -99.38,17.3 -21.7,24.97 -42.05,62.7 -16.83,88.08 z"
                              @click="handleClick(event,36)"
                        />
                        <path id="tooth37"
                              :class="isSelected(37)?'selected':''"
                              :style="getStyle(37)"
                              style="fill:url(#linearGradientLower4459-9-5);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 583.9,732.87 c 17,23.86 76.95,11.58 98.57,3.46 47.32,-17.8 38.15,-93.57 17.63,-115.14 -21.1,-22.2 -69.1,3.5 -88.74,22 -20.55,19.3 -56.47,49 -27.47,89.6 z"
                              @click="handleClick(event,37)"
                        />
                        <path id="tooth38"
                              :class="isSelected(38)?'selected':''"
                              :style="getStyle(38)"
                              style="fill:url(#linearGradientLower4467-2-7);fill-opacity:1;fill-rule:evenodd;stroke:none"
                              d="m 609.8,821.98 c 18.24,22.56 58.58,25.1 77.3,15.68 23.95,-12.07 24,-56.68 7.77,-76.5 -15.17,-18.55 -63.54,-16.33 -80.07,1.1 -19.7,20.8 -22.35,38.27 -5,59.72 z"
                              @click="handleClick(event,38)"
                        />
                    </g>

                    <g id="teeth-lower-texts" transform="matrix(1,0,0,-1,0,893.79226)">
                        <text xml:space="preserve"
                              x="433.42178"
                              y="-95.072319"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(31, 433.42178, -80.072319)"
                        />
                        <text xml:space="preserve"
                              x="527.15228"
                              y="-130.76456"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(32, 527.15228, -120.76456)"
                        />
                        <text xml:space="preserve"
                              x="600.82513"
                              y="-185.11057"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(33, 600.82513, -175.11057)"
                        />
                        <text xml:space="preserve"
                              x="648.04224"
                              y="-305.41785"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(34, 648.04224, -295.41785)"
                        />
                        <text xml:space="preserve"
                              x="658.05573"
                              y="-422.91751"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(35, 658.05573, -412.91751)"
                        />
                        <text xml:space="preserve"
                              x="648.05573"
                              y="-547.30176"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(36, 648.05573, -537.30176)"
                        />
                        <text xml:space="preserve"
                              x="653.01727"
                              y="-685.4552"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(37, 653.01727, -675.4552)"
                        />
                        <text xml:space="preserve"
                              x="654.49805"
                              y="-794.07025"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(38, 654.49805, -784.07025)"
                        />

                        <text xml:space="preserve"
                              x="320.36444"
                              y="-92.995377"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(41, 320.36444, -80.072319)"
                        />
                        <text xml:space="preserve"
                              x="223.07625"
                              y="-130.68762"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(42, 223.07625, -120.76456)"
                        />
                        <text xml:space="preserve"
                              x="151.03801"
                              y="-185.47592"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(43, 151.03801, -175.11057)"
                        />
                        <text xml:space="preserve"
                              x="100.69201"
                              y="-304.89862"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(44, 100.69201, -295.41785)"
                        />
                        <text xml:space="preserve"
                              x="92.768944"
                              y="-422.99448"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(45, 92.768944, -412.91751)"
                        />
                        <text xml:space="preserve"
                              x="101.1343"
                              y="-547.82098"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(46, 101.1343, -537.30176)"
                        />
                        <text xml:space="preserve"
                              x="100.69201"
                              y="-685.5321"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(47, 100.69201, -675.4552)"
                        />
                        <text xml:space="preserve"
                              x="93.730476"
                              y="-793.18567"
                              transform="scale(1,-1)"
                              v-html="getToothTexts(48, 93.730476, -784.07025)"
                        />
                    </g>
                </svg>
            </div>
        </div>
    </div>
</template>

<style>
    #mobile-tooth-selector-container {
        overflow: hidden;
    }
    #mobile-tooth-selector {
        text-align: center;
        width: Calc(100vw - 30px);
        height: Calc((100vw - 20px) * 1.33);
        max-height: Calc(100vh - 190px);
        margin: 20px 0px 0 0px;
        padding: 0;
        position: relative;
        display: block;
    }
    .selected-jaw-none #svg-lower, .selected-jaw-none #svg-upper {
        width: 45vw;
        position: absolute;
        transition: all .5s;
        left: 50%;
        margin-left: -22.5vw;
         z-index: 2;
    }

    .selected-jaw-none #svg-lower {
        bottom: 0;
    }

    .selected-jaw-none #svg-upper {
        top: 0;
    }

    .selected-jaw-upper #svg-lower, .selected-jaw-lower #svg-upper {
        width: 36vw;
        position: absolute;
        left: 50%;
        margin-left: -18vw;
        opacity: .2;
        z-index: 3;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
        transition: all .5s;
    }

    .selected-jaw-upper #svg-lower {
        bottom: 0;
    }

    .selected-jaw-lower #svg-upper {
        top: 0;
    }

    .selected-jaw-lower #svg-lower, .selected-jaw-upper #svg-upper {
        width: 80vw;
        position: absolute;
        left: 50%;
        margin-left: -40vw;
        z-index: 2;
        transition: all .5s;
    }

    .selected-jaw-lower #svg-lower {
        bottom: 0;
    }

    .selected-jaw-upper #svg-upper {
        top: 0;
    }

    #mobile-tooth-selector svg path.selected {
        stroke:#337ab7!important;
        stroke-width:5!important;
    }

    #mobile-tooth-selector svg path, #mobile-tooth-selector svg circle, #mobile-tooth-selector svg text {
        pointer-events: none;
        color: #000;
    }
    #mobile-tooth-selector svg #teeth-upper-tooth path, #mobile-tooth-selector svg #teeth-lower-tooth path {
        pointer-events: all;
        cursor: pointer;
    }
</style>

<script>
import ToothChartService from "@/utils/tooth-chart";

export default {
    props: {
        jaw: {
            type: String,
            default: "upper",
        },
        selected: {
            type: Array,
            default: () => {return ([]);},
        },
    },
    data: function() {
        const lastJaw = localStorage.getItem('lastSvgJaw') || 'upper';
        const selectedJaw = this.selected.length > 0 ? (this.selected[0]> 30 ? 'lower' : 'upper') : lastJaw;
        return ({
            doubleTapTimer: null,
            prevTouchedTooth: null,
            firstTouchedTooth: null,
            firstTouchedToothSelected: false,
            touchStartId: null,
            touchMoveId: null,
            selectedTmp: [],
            selectedJaw: selectedJaw,
        });
    },
    watch: {
        selectedJaw: function() {
            this.$emit("toggleJaw", this.selectedJaw);
            localStorage.setItem('lastSvgJaw', this.selectedJaw);
        },
    },
    methods: {
        toggleJaw: function(e, jaw) {
            if (jaw === this.selectedJaw) return;
            this.selectedJaw = jaw;
            e.stopPropagation();
        },
        getToothTexts: function(id, x, y) {
            return ToothChartService.getToothTexts(id, x, y, this.isSelected(id));
        },

        getStyle: function(id) {
            return("");
        },

        isSelected: function(id) {
            if (this.selected.indexOf(id) !== -1) return true;
            if (this.selectedTmp.indexOf(id) !== -1) return true;
            return false;
        },
        select: function(id) {
            this.$emit("update:state", false);
            this.$emit("select", id);
        },
        requireSelection: function() {
            if (this.selected.length === 0) {
                this.$root.showSnackbar({
                    color: "blue-grey darken-4",
                    timeout: 2500,
                    text: this.$t("dialog_select_state.select_tooth"),
                });
                return false;
            }
            return true;
        },

        handleClick: function(e, tid) {
            if (this.selectedJaw === "none") return false;
            if (tid > 30 && this.selectedJaw === "upper") return false;
            if (tid < 30 && this.selectedJaw === "lower") return false;
            const idx = this.selected.indexOf(tid);
            if (this.firstTouchedTooth === tid) return;
            if (idx === -1) {
                this.selected.push(tid);
            } else {
                this.selected.splice(idx, 1);
            }
        },
        processTouchStart: function(ev) {
            if (this.selectedJaw === "none") return false;
            const self = this;
            const el = document.elementFromPoint(ev.touches[0].clientX, ev.touches[0].clientY);
            this.firstTouchedTooth = null;
            this.prevTouchedTooth = null;
            this.selectedTmp = [];
            this.noScrollAble = false;
            this.firstTouchedToothSelected = false;
            if (el.tagName !== "path") {
                if (self.doubleTapTimer == null) {
                    self.doubleTapTimer = setTimeout(function() {
                        self.doubleTapTimer = null;
                    }, 500);
                } else {
                    clearTimeout(self.doubleTapTimer);
                    self.doubleTapTimer = null;
                    this.selected = [];
                }
            } else {
                this.noScrollAble = true;
                const tid = parseInt(el.id.replace("tooth", ""));
                if (tid > 30 && this.selectedJaw === "upper") return false;
                if (tid < 30 && this.selectedJaw === "lower") return false;
                if (this.selected.indexOf(tid) >= 0) {
                    this.firstTouchedToothSelected = true;
                    this.selected.splice(this.selected.indexOf(tid), 1);
                    this.$emit("updateSelection", this.selected);
                } else {
                    this.selectedTmp.push(tid);
                    this.firstTouchedTooth = tid;
                }
            }
        },
        processTouchMove: function(ev) {
            if (this.selectedJaw === "none") return false;
            const el = document.elementFromPoint(ev.touches[0].clientX, ev.touches[0].clientY);
            if (this.noScrollAble) {
                ev.preventDefault();
            }

            if (typeof (el) === "undefined" || el === null) return false;
            if (el.tagName == "path") {
                const tid = parseInt(el.id.replace("tooth", ""));
                if (tid > 30 && this.selectedJaw === "upper") return false;
                if (tid < 30 && this.selectedJaw === "lower") return false;

                // Move from selected to selectedTmp
                if (this.selected.indexOf(tid) >= 0) {
                    this.selected.splice(this.selected.indexOf(tid), 1);
                }

                if (!this.firstTouchedTooth) this.firstTouchedTooth = tid;
                if (this.firstTouchedTooth !== tid || this.prevTouchedTooth !== tid) {
                    if (Math.floor(tid / 10) === Math.floor(this.firstTouchedTooth / 10)) {
                        // Same side, select all from start to end
                        if (tid < this.firstTouchedTooth) {
                            var j = 1;
                        } else {
                            var j = -1;
                        }
                        this.selectedTmp = [];
                        this.selectedTmp.push(this.firstTouchedTooth);
                        for (let tmpId = tid; tmpId !== this.firstTouchedTooth; tmpId += j) {
                            this.selectedTmp.push(tmpId);
                        }
                    } else {
                        this.selectedTmp = [];
                        for (let tmpId = this.firstTouchedTooth; tmpId % 10 !== 0; tmpId -= 1) {
                            this.selectedTmp.push(tmpId);
                        }
                        for (let tmpId = tid; tmpId % 10 !== 0; tmpId -= 1) {
                            this.selectedTmp.push(tmpId);
                        }
                    }
                }
                this.prevTouchedTooth = tid;
            }
            if (el.tagName == "path" || el.tagName == "g" || el.tagName == "svg" || el.tagName == "text" || el.tagName == "tspan") {
                ev.preventDefault();
            }
        },
        processTouchEnd: function(ev) {
            if (this.selectedJaw === "none") return false;
            if (this.selectedTmp.length === 1 && this.firstTouchedToothSelected) this.selectedTmp = [];
            if (this.selectedTmp.length > 0) this.selected = this.selected.concat(this.selectedTmp);
            this.selectedTmp = [];
            this.$emit("updateSelection", this.selected);
            if (this.firstTouchedToothSelected) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        },
    },
    filters: {},
};
</script>
